angular
    .module('dashboard')
    .directive('communicationMessageVariableReplacement',
        function () {
            return {
                scope: {
                    type: '=',
                    callback: '=',
                    isBrandContext: '<'
                },
                templateUrl: 'components/campaigndesigner/managecampaigntemplates/commssetup/communicationmessagevariablereplacement/communicationmessagevariablereplacement.fbb2ee69.html',
                restrict: 'E',
                link: function (scope, elm, attr) {
                    scope.callcallback = function callcallback(variableName) {
                        scope.callback(scope.type, variableName);
                    };

                    scope.isSmsCommunication = function () {
                        return scope.type === window.Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.sms;
                    }

                    scope.isInboxCommunication = () => {
                        return scope.type === window.Dashboard.Models.Lookups
                            .CampaignTemplateCommunicationTypes.inbox;
                    }
                }
            };
        });

